import fiservImage from "itd-common/assets/images/issuers/FISERV.png"
import logoPix from "itd-common/assets/images/issuers/Logo_Pix.svg"
import visaImage from "itd-common/assets/images/issuers/VISA.png"
import maestroImage from "itd-common/assets/images/issuers/MAESTRO.png"
import ocaImage from "itd-common/assets/images/issuers/OCA.png"
import sodexoImage from "itd-common/assets/images/issuers/SODEXO.png"
import midesImage from "itd-common/assets/images/issuers/mides20.jpg"
import masterImage from "itd-common/assets/images/issuers/MASTERCARD.png"
import masterDebit from "itd-common/assets/images/issuers/Debit_Mastercard_logo.svg"
import cabalImage from "itd-common/assets/images/issuers/CABAL.png"
import creditelImage from "itd-common/assets/images/issuers/CREDITEL.png"
import passcardImage from "itd-common/assets/images/issuers/Passcard_Principal.svg"
import edenredImage from "itd-common/assets/images/issuers/EDENRED.png"
import creditosdirectosImage from "itd-common/assets/images/issuers/CREDITOSDIRECTO.png"
import amexdirectosImage from "itd-common/assets/images/issuers/AMERICANEXPRESS.png"
import clubdelesteImage from "itd-common/assets/images/issuers/CLUBDELESTE.png"
import andaImage from "itd-common/assets/images/issuers/ANDA.png"
import totalnetImage from "itd-common/assets/images/issuers/TOTALNET.png"
import ankImage from "itd-common/assets/images/issuers/ankLogo.png"
import beloImage from "itd-common/assets/images/issuers/beloLogo.png"
import claveImage from "itd-common/assets/images/issuers/claveLogo.png"
import farmacloudImage from "itd-common/assets/images/issuers/farmacloudLogo.png"
import finketImage from "itd-common/assets/images/issuers/finketLogo.png"
import meliImage from "itd-common/assets/images/issuers/meliLogo.png"
import nvioImage from "itd-common/assets/images/issuers/nvioLogo.png"
import ohanaImage from "itd-common/assets/images/issuers/ohanaLogo.png"
import payCloudImage from "itd-common/assets/images/issuers/payCloudLogo.png"
import propagoImage from "itd-common/assets/images/issuers/propagoLogo.png"
import provinciaImage from "itd-common/assets/images/issuers/provinciaLogo.jpg"
import totalCoinImage from "itd-common/assets/images/issuers/totalCoinLogo.png"
import viumiImage from "itd-common/assets/images/issuers/viumiLogo.png"
import walmartImage from "itd-common/assets/images/issuers/walmartLogo.png"
import yacareImage from "itd-common/assets/images/issuers/yacareLogo.png"
import liderImage from "itd-common/assets/images/issuers/logo_lider.png"
import tokeImage from "itd-common/assets/images/issuers/toke.svg"
import argenCardImage from  "itd-common/assets/images/issuers/argencard.png"
import dinersImage from  "itd-common/assets/images/issuers/diners_club.png"
import i18next from "i18next";
import {WebCache} from "../services/WebCache";
import agilPagosSvg from  "itd-common/assets/images/issuers/AGILPAGOS.svg"
import bind from  "itd-common/assets/images/issuers/BIND.svg"
import bnaImage from  "itd-common/assets/images/issuers/BNA.svg"
import bruLogo from  "itd-common/assets/images/issuers/BRUBANK.svg"
import buepp from  "itd-common/assets/images/issuers/BUEPP.svg"
import callaoImage from  "itd-common/assets/images/issuers/CALLAO.svg"
import cencoImage from  "itd-common/assets/images/issuers/CENCOPAY.svg"
import claroPayImage from "itd-common/assets/images/issuers/CLAROPAY.svg"
import dolarAppImage from "itd-common/assets/images/issuers/DOLARAPP.svg"
import nbch from "itd-common/assets/images/issuers/NBCH.svg"
import dniImage from  "itd-common/assets/images/issuers/CUENTADNI.svg"
import epagosImage from  "itd-common/assets/images/issuers/EPAGOS.svg"
import fertil from  "itd-common/assets/images/issuers/FERTILSUMA.svg"
import hooliImage from  "itd-common/assets/images/issuers/HOOLI.svg"
import klioImage from  "itd-common/assets/images/issuers/KLIO.svg"
import modoImage from  "itd-common/assets/images/issuers/MODO.svg"
import moniImage from  "itd-common/assets/images/issuers/MONI.svg"
import mercadoPagoImage from  "itd-common/assets/images/issuers/MP.svg"
import naranjaImage from  "itd-common/assets/images/issuers/NARANJAX.svg"
import payImage from  "itd-common/assets/images/issuers/PERSONALPAY.svg"
import plusPagosImage from  "itd-common/assets/images/issuers/PLUSPAGOS.svg"
import prexImage from  "itd-common/assets/images/issuers/PREX.svg"
import pvs from  "itd-common/assets/images/issuers/PVS.svg"
import resimpleImage from  "itd-common/assets/images/issuers/RESIMPLE.svg"
import sidompay from  "itd-common/assets/images/issuers/SIDOMPAY.svg"
import telepagosImage from  "itd-common/assets/images/issuers/TELEPAGOS.svg"
import ualaImage from  "itd-common/assets/images/issuers/UALA.svg"
import ultra from  "itd-common/assets/images/issuers/ULTRA.svg"
import lemonImage from "itd-common/assets/images/issuers/LEMON.svg"
import credencialPayments from "itd-common/assets/images/issuers/cPayments.png"
import unionPayImage from "itd-common/assets/images/issuers/UnionPay_logo.svg"
import {Capacitor} from "@capacitor/core";

export class UtilService { 

    public static isMobilePlatform(): boolean {
        const ua = navigator.userAgent;
        return /iPhone/.test(ua) || /Android/.test(ua);
    }

    public static isNative():boolean{
        return Capacitor.isNativePlatform();
    }

    public static getCurrencyOptions=function(){
        let res=[];
        const all = new Option();
        all.value = "";
        all.label = i18next.t("all");
        res.push(all);
        var currencies= WebCache.getCurrencies();
        for(var i in currencies){
            let c = new Option();
            c.value = currencies[i].id;
            c.label = currencies[i].name;
            res.push(c);
        }
        return res;
    }

    public static getDDMMyyFormatFromString = function(value:string) {
        if(value.toString().length>10){
            let f=value.toString().substring(0,10).split("-");
            return f[2]+"/"+f[1]+"/"+f[0];
        }else
            return value+"";
    };

    public static getDDMMyyHHmmssFormatFromString = function(value:string) {

        if(value.toString().length>10){
            let f=value.toString().split(" ")[0].split("/");
            let f2=value.toString().split(" ")[1].split(":");
            return f[0]+"/"+f[1]+"/"+f[2]+" "+f2[0]+"h"+f2[1];
        }else
            return value+"";
    };

    public static getYYYY_MM_DDFormat = function(date:Date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();
        return [
            date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
        ].join('-');
    };

    public static getYYYY_MM_DDMinusDaysFormat = function(days:number) {
        var d = new Date();
        d.setDate(d.getDate()-days)
        return UtilService.getYYYY_MM_DDFormat(d);
    };

    public static mobileCheck = function() {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
        return check;
    };

    public static isSmallScreen = function() {
        const { innerWidth: width, innerHeight: height } = window;
        return width<992
    };

    public static getImageTag = function(issuer:string){
        let src="";
        if(issuer!=null)
            issuer=issuer.toUpperCase();
        if (issuer.indexOf("VISANET")>=0){
            src=totalnetImage;
        }else if (issuer.indexOf("MERCADO PAGO")>=0){
            src=mercadoPagoImage;
        }else if (issuer.indexOf("ADELANTO LIQUIDACIÓN MASTER")>=0){
            src=masterImage;
        }else if (issuer.indexOf("ADELANTO LIQUIDACIÓN VISA")>=0){
            src=visaImage;
        }else if (issuer.indexOf("VISA")>=0){
            src=visaImage;
        }else if (issuer.indexOf("ARGENCARD")>=0){
            src=argenCardImage;
        }else if (issuer.indexOf("DINERS")>=0){
            src=dinersImage;
        }else if (issuer.indexOf("MAESTRO")>=0){
            src=maestroImage
        }else if (issuer.indexOf("OCA")>=0){
            src=ocaImage
        }else if (issuer.indexOf("LIDER SODEXO")>=0){
            src=sodexoImage
        }else if (issuer.indexOf("SODEXO")>=0){
            src=sodexoImage
        }else if (issuer.indexOf("MIDES")>=0){
            src=midesImage
        }else if (issuer.indexOf("MCDEBITO") >=0 || issuer.indexOf("MASTERCARD DEBIT")>=0){
            src=masterDebit;
        }else if (issuer.indexOf("MASTERCARD PREPAGO")>=0){           
            src=masterImage
        }else if (issuer.indexOf("MASTERCARD")>=0){
            src=masterImage
        }else if (issuer.indexOf("CABAL")>=0){
            src=cabalImage
        }else if (issuer.indexOf("CREDITEL")>=0){
            src=creditelImage
        }else if (issuer.indexOf("PASS CARD")>=0){
            src=passcardImage
        }else if (issuer.indexOf("EDENRED")>=0){
            src=edenredImage
        }else if (issuer.indexOf("C. DIRECTOS")>=0){
            src=creditosdirectosImage
        }else if (issuer.indexOf("AMEX")>=0){
            src=amexdirectosImage
        }else if (issuer.indexOf("American Express".toUpperCase())>=0){
            src=amexdirectosImage            
        }else if (issuer.indexOf("LIDER")>=0){
            src=liderImage
        }else if (issuer.indexOf("TOKE")>=0){
            src=tokeImage
        }else if (issuer.indexOf("CLUB DEL ESTE")>=0){
            src=clubdelesteImage
        }else if (issuer.indexOf("ANDA")>=0){
            src=andaImage
        }else if (issuer.indexOf("FISERV")>=0){
            src=fiservImage;
        }else if (issuer.indexOf("PIX")>=0){
            src=logoPix;
        }else if (issuer.indexOf("AGIL")>=0){
            src=agilPagosSvg;
        }else if (issuer.indexOf("ANK")>=0){
            src=ankImage;
        }else if (issuer.indexOf("BELO")>=0){
            src=beloImage;
        }else if (issuer.indexOf("BNA+")>=0){
            src=bnaImage;
        }else if (issuer.indexOf("CALLAO")>=0){
            src=callaoImage;
        }else if (issuer.indexOf("CENCO")>=0){
            src=cencoImage;
        }else if (issuer.indexOf("CLARO PAY")>=0){
            src=claroPayImage;
        }else if (issuer.indexOf("CLAVE")>=0){
            src=claveImage;
        }else if (issuer.indexOf("CDNI")>=0){
            src=dniImage;
        }else if (issuer.indexOf("DOLAR APP")>=0){
            src=dolarAppImage;
        }else if (issuer.indexOf("EPAGOS")>=0){
            src=epagosImage;
        }else if (issuer.indexOf("FARMA CLOUD")>=0){
            src=farmacloudImage;
        }else if (issuer.indexOf("FINKET")>=0){
            src=finketImage;
        }else if (issuer.indexOf("HOOLI")>=0){
            src=hooliImage;
        }else if (issuer.indexOf("KLIO")>=0){
            src=klioImage;
        }else if (issuer.indexOf("MELI")>=0){
            src=meliImage;
        }else if (issuer.indexOf("MODO")>=0){
            src=modoImage;
        }else if (issuer.indexOf("MONI ONLINE")>=0){
            src=moniImage;
        }else if (issuer.indexOf("NARANJA X")>=0){
            src=naranjaImage;
        }else if (issuer.indexOf("NVIO")>=0){
            src=nvioImage;
        }else if (issuer.indexOf("OHANA")>=0){
            src=ohanaImage;
        }else if (issuer.indexOf("PAY CLOUD")>=0){
            src=payCloudImage;
        }else if (issuer.indexOf("PERSONAL PAY")>=0){
            src=payImage;
        }else if (issuer.indexOf("PLUS PAGOS")>=0){
            src=plusPagosImage;
        }else if (issuer.indexOf("PREX")>=0){
            src=prexImage;
        }else if (issuer.indexOf("PROPAGO")>=0){
            src=propagoImage;
        }else if (issuer.indexOf("PROVINCIA")>=0){
            src=provinciaImage;
        }else if (issuer.indexOf("RESIMPLE")>=0){
            src=resimpleImage;
        }else if (issuer.indexOf("TELEPAGOS")>=0){
            src=telepagosImage;
        }else if (issuer.indexOf("TOTAL COIN")>=0){
            src=totalCoinImage;
        }else if (issuer.indexOf("UALA")>=0){
            src=ualaImage;
        }else if (issuer.indexOf("VIUMI")>=0){
            src=viumiImage;
        }else if (issuer.indexOf("WALMART")>=0){
            src=walmartImage;
        }else if (issuer.indexOf("YACARE")>=0){
            src=yacareImage;
        }else if (issuer.indexOf("BIND PAGO SA")>=0){
            src=bind;
        }else if (issuer.indexOf("BRUBANK")>=0){
            src=bruLogo;
        }else if (issuer.indexOf("BUEPP")>=0){
            src=buepp;
        }else if (issuer.indexOf("FERTIL FINANZAS S.A.")>=0){
            src=fertil;
        }else if (issuer.indexOf("PAGO VIRTUAL DEL SUR S.A")>=0){
            src=pvs;
        }else if (issuer.indexOf("ULTRA WALLET")>=0){
            src=ultra;
        }else if (issuer.indexOf("SIDOM PAY SA")>=0){
            src=sidompay;
        }else if (issuer.indexOf("BANCO EL CHACO")>=0){
            src=nbch;
        }else if (issuer.indexOf("LEMON")>=0){
            src= lemonImage
        }else if (issuer.indexOf("CPAYMENTS")>=0){
            src= credencialPayments
        }else if (issuer.indexOf("UNION PAY")>=0){
            src= unionPayImage
        }
        return src;
    }

    public static getIssuerGridValueInt = function(value:any,columnName:string,t:any){
        const processedValue = t(columnName + "-" + value).toUpperCase();
        const image = UtilService.getImageTag(processedValue);
        let displayValue = "";
        if (processedValue.indexOf("VISA") >= 0) {
            displayValue = " " + processedValue.replace("VISA", "").trim().toLowerCase();
            if (displayValue.trim() === "") {
                displayValue = t("credit");
            }
        } else if (processedValue.indexOf("MAESTRO") >= 0) {
            displayValue = "";
        } else if (processedValue.indexOf("OCA") >= 0) {
            displayValue = " " + processedValue.replace("OCA", "").trim().toLowerCase();
            if (displayValue.trim() === "card") {
                displayValue = t("credit");
            }
        } else if (processedValue.indexOf("CENCO") >= 0) {
            displayValue = "CENCOSUD".trim().toLowerCase();
        } else if (processedValue.indexOf("MASTERCARD") >= 0) {
            displayValue = " " + processedValue.replace("MASTERCARD", "").trim().toLowerCase();
            if (displayValue.trim().length === 0) {
                displayValue = t("credit");
            }
        } else if (processedValue.indexOf("CABAL") >= 0) {
            displayValue = " " + processedValue.replace("CABAL", "").trim().toLowerCase();
        } else if (processedValue.indexOf("CREDITEL") >= 0) {
            displayValue = " " + processedValue.replace("CREDITEL", "").trim().toLowerCase();
        } else if (processedValue.indexOf("PASS CARD") >= 0) {
            displayValue = " " + processedValue.replace("PASS CARD", "").trim().toLowerCase();
        } else if (processedValue.indexOf("EDENRED") >= 0) {
            displayValue = " " + processedValue.replace("EDENRED", "").trim().toLowerCase();
        } else if (processedValue.indexOf("PIX") >= 0) {
            displayValue = "";
        } else if (processedValue.indexOf("UNION PAY") >= 0){
            displayValue = " " + processedValue.replace("UNION PAY", "").trim().toLowerCase();
            if (displayValue.trim() === "") {
                displayValue = t("credit");
            }
        } else {
            if(image==null||image.length==0){
                let tmpIssuer=WebCache.getAllIssuers().find((iss:any) => (iss.id+"")
                    .padStart(4,"0") == (value+"").padStart(4,"0"));
                if(tmpIssuer!=null)
                    displayValue = tmpIssuer.issuerName.toUpperCase();
                else
                    displayValue = processedValue;
            }else
                displayValue ="";
        }
        return { value: displayValue, image };
    };

    public static getIssuerGridValue = function(value:any,i:number,val:any,t:any,columns:any){
        return UtilService.getIssuerGridValueInt(value,columns[i],t);
    }

    static getDateFromDDMMyyyy(date: string) {
        var fields=date.split("/");
        return fields[2]+"-"+fields[1]+"-"+fields[0];
    }
}
